import React  from 'react';
import { Link,useHistory, useLocation } from 'react-router-dom';
import { selectMenu  } from '.././../actions/index';
import { useDispatch,useSelector } from 'react-redux';
import 'react-toastify/dist/ReactToastify.css';
import Sidebar from "./sidebar/Sidebar";
import DesktopMenu from "./DesktopMenu";
import { useMediaQuery } from 'react-responsive'

const Header = (match) => { 
    
  const history = useHistory({forceRefresh:true});
  const location = useLocation();
  const dispatch = useDispatch();
  dispatch(selectMenu(match)); 
  const loginuser = useSelector((state) => state.setUserlog); 

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1224px)' })
  const isPortrait = useMediaQuery({ query: '(orientation: portrait)' })

  // Hide header completely on join-auction-code3 page (regardless of login status)
  const shouldHideHeader = location.pathname === '/join-auction-code4';
    
  return (
    <>
      {!shouldHideHeader && (
        <>
          {isTabletOrMobile || isPortrait ? (
            <>
              <Sidebar hideNavigation={location.pathname === '/join-auction-code3'}/>
              <div className='mob-top'></div>
            </>
          ) : (
            <DesktopMenu data={match} hideNavigation={location.pathname === '/join-auction-code3'}/> 
          )}   
        </>
      )}
    </>
  )
}

export default Header
